import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/App";

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${API}/analytics/pageview`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || "",
          }),
        });
      } catch {}
    };
    track();
  }, [location.pathname]);

  return null;
};
